// extracted by mini-css-extract-plugin
export var aggregationCell = "_2g-t";
export var aggregationRow = "_2g-s";
export var borderlessSpinnerContainer = "_2g-3";
export var cardLayout = "_2g-6";
export var cardLayoutNoFooter = "_2g-a";
export var cardLayoutPageControl = "_2g-9";
export var cardLayoutWithFooter = "_2g-8";
export var closeIcon = "_2g-l";
export var columnHeaderSurface = "_2g-d";
export var columnHeaderSurfaceDragOverlay = "_2g-11";
export var columnHeaderSurfaceResizing = "_2g-y";
export var contextMenuAnchor = "_2g-1";
export var draggableColumnHeader = "_2g-z";
export var draggableColumnHeaderOverlay = "_2g-10";
export var expandIcon = "_2g-m";
export var expanded = "_2g-n";
export var filterBackIcon = "_2g-g";
export var filterButtonAnchor = "_2g-f";
export var filterDropdown = "_2g-o";
export var filterDropdownDivider = "_2g-j";
export var filterDropdownHeader = "_2g-r";
export var filterDropdownItem = "_2g-q";
export var filterDropdownModal = "_2g-p _2g-o";
export var filterItem = "_2g-e";
export var normalCellWithAdjustableBorder = "_2g-k";
export var pinButtonContainer = "_2g-u";
export var pinIcon = "_2g-v";
export var pinIconActive = "_2g-w";
export var spinner = "_2g-0";
export var spinnerContainer = "_2g-2";
export var subFilterArrowIcon = "_2g-h";
export var tableContainer = "_2g-4";
export var tableContentDraggingColumns = "_2g-c";
export var tableContentInner = "_2g-7";
export var tableContentInnerFill = "_2g-b";
export var tableContentWrapper = "_2g-5";
export var toolbarEnd = "_2g-i";
export var viewButtonContainer = "_2g-x";